import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import {$events} from "../helpers/events";
import {isElement} from "../helpers/_utilities";
import variables from "../variables";

const {addClass, removeClass, callAll} = $dom

const groupSelector = '.js-animated-label-group'
const inputSelector = '.js-animated-label-field'

export default function () {
    const handleField = e => {
        let target;

        e instanceof Event ? target = e.target : target = e

        if (isElement(target)) {
            target.value.length > 0
                ? addClass(target, variables.classNames.filled)
                : removeClass(target, variables.classNames.filled)
        }

    }

    const checkAllFields = () => callAll(inputSelector, handleField)

    return new Component({
        name: 'animatedLabel',
        requiredTargets: groupSelector,
        onInit() {
            checkAllFields()
            $events.delegate.on('input', inputSelector, handleField)
        },
        onDestroy() {
            $events.delegate.off('input', inputSelector, handleField)
        },
    })

};